// Zoeklade (#87): open/dicht via [open] op .zoek-lade (de beweging staat in theme.css),
// en vanaf twee tekens live shafts uit sections/zoek-suggesties.liquid via de
// Section Rendering API van predictive search. Zonder dit script blijft de lade dicht.

const zoek = document.querySelector('.zoek');
if (zoek) {
  const knop = zoek.querySelector('[aria-expanded]');
  const lade = zoek.querySelector('.zoek-lade');
  const veld = zoek.querySelector('input[type="search"]');
  const treffers = zoek.querySelector('.zoek-treffers');
  let timer;
  let lopend; // AbortController van het laatste verzoek: het laatste wint

  const open = () => {
    lade.removeAttribute('inert');
    lade.setAttribute('open', '');
    knop.setAttribute('aria-expanded', 'true');
    veld.focus();
  };
  const sluit = () => {
    lade.removeAttribute('open');
    lade.setAttribute('inert', '');
    knop.setAttribute('aria-expanded', 'false');
  };
  const isOpen = () => lade.hasAttribute('open');

  knop.addEventListener('click', () => (isOpen() ? sluit() : open()));
  zoek.querySelector('[data-zoek-sluit]').addEventListener('click', () => { sluit(); knop.focus(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && isOpen()) { sluit(); knop.focus(); } });
  document.addEventListener('click', (e) => { if (isOpen() && !zoek.contains(e.target)) sluit(); });

  // Het oude blok fadet 6px weg (raster-weg), dan komt het nieuwe en rijzen de kaarten
  // 40ms na elkaar op. Onder reduced-motion duren de animaties 0ms en wisselt het direct.
  const toon = async (nieuw) => {
    const oud = treffers.firstElementChild;
    if (oud) {
      oud.classList.add('weg');
      await Promise.all(oud.getAnimations().map((a) => a.finished)).catch(() => {});
    }
    treffers.replaceChildren(...(nieuw ? [nieuw] : []));
    nieuw?.querySelectorAll('.product').forEach((kaart, i) => kaart.style.setProperty('--i', i));
  };

  const haal = async (term) => {
    lopend?.abort();
    lopend = new AbortController();
    const url = `${treffers.dataset.url}?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=10&section_id=zoek-suggesties`;
    try {
      const html = await (await fetch(url, { signal: lopend.signal })).text();
      const uitkomst = new DOMParser().parseFromString(html, 'text/html').querySelector('.zoek-uitkomst');
      if (uitkomst) toon(uitkomst);
    } catch (e) {
      if (e.name !== 'AbortError') console.error(e); // ponytail: netwerkfout = oude treffers blijven staan
    }
  };

  veld.addEventListener('input', () => {
    clearTimeout(timer);
    const term = veld.value.trim();
    if (term.length < 2) { lopend?.abort(); toon(null); return; }
    timer = setTimeout(() => haal(term), 200);
  });
}
